const { useNavigate } = require("react-router-dom");
// const { default: ManejoNotificacionesEnAndroid } = require("./ManejoNotificacionesEnAndroid");

// Define placeholder functions to ensure static exports exist
let requestForToken = async () => { };
let onMessageListener = () => { };
let unsubscribeFromNotifications = async () => { };
let unsubscribe = async () => { };
let savetoken = async (token) => { };

function detectarDispositivo() {
  const userAgent = navigator.userAgent;

  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent)) {
    return "Celular";
  } else {
    return "Computadora";
  }
}

if (process.env.NODE_ENV === 'production' || detectarDispositivo() === "Computadora") {
  const { initializeApp } = require("firebase/app");
  const { getAnalytics } = require("firebase/analytics");
  const { getMessaging, getToken, onMessage, deleteToken } = require("firebase/messaging");
  const Mensaje = require("./Mensaje").default;
  const NotificacionesEnAndroid = require("./NotificacionesEnAndroid").default;
  const Config = require("./Config").default;
  const Cargando = require("./Cargando").default;
  const Swal = require('sweetalert2');
  const { Capacitor } = require('@capacitor/core');

  const firebaseConfig = {
    apiKey: "AIzaSyCvCWX0vYdyU3o14Qjz6Roi0991JmQE0LI",
    authDomain: "app-sisges.firebaseapp.com",
    projectId: "app-sisges",
    storageBucket: "app-sisges.appspot.com",
    messagingSenderId: "60803896962",
    appId: "1:60803896962:web:785daa63f6b10dda8bc69b",
    measurementId: "G-5W07MBTXGZ"
  };

  const app = initializeApp(firebaseConfig);
  const analytics = getAnalytics(app);
  const messaging = getMessaging(app);

  const { BorrarTodosLosMensajes, SetMensaje } = Mensaje();
  const { StartCargando, StopCargando } = Cargando();
  const { requestPushPermission, unregister } = NotificacionesEnAndroid();

  let isRequestingToken = false;

  const saveTokenAndSendToServer = async (token) => {
    try {
      if (token) {
        const userlogintokenString = localStorage.getItem('token');
        const userlogintoken = JSON.parse(userlogintokenString);

        const response = await Config.AddTokenNotificacion({ token: token }, userlogintoken);

        if (response.data.sucess) {
          StopCargando();
          localStorage.setItem('fcm_token', token);
        } else {
          StopCargando();
          SetMensaje("Error", "Error al activar notificaciones", 3000);
        }
      } else {
        StopCargando();
        SetMensaje("Error", "Error al activar notificacion", 3000);
        console.log('No se pudo generar el token.');
      }
    } catch (error) {
      // Error handling
      const token = localStorage.getItem("token");
      if (token && !Capacitor.isNativePlatform()) {
        SetMensaje("Error", "Error al activar notificacion", 3000);
      }
      console.error('Error obteniendo token FCM', error);
    }
  };

  requestForToken = async () => {
    // Verificamos si ya tenemos un token almacenado en localStorage
    const storedToken = localStorage.getItem('fcm_token');
    if (storedToken) {
      return storedToken;
    }

    if (isRequestingToken) {
      return;
    }

    const userString = localStorage.getItem('user');
    const user = JSON.parse(userString);
    const DNIUsuario = user.dni;
    if (DNIUsuario == "" || DNIUsuario === null) {
      return;
    }

    const userdeseanotificaciones = localStorage.getItem('deseanotificaciones');

    if (userdeseanotificaciones === "NO") {
      return;
    }

    try {
      isRequestingToken = true;

      const result = await Swal.fire({
        title: 'Notificaciones',
        text: "¿Te gustaría recibir notificaciones sobre tus puntos y premios?",
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Sí, quiero recibir',
        cancelButtonText: 'No, gracias',
        reverseButtons: true,
        customClass: {
          popup: 'popup-custom-class'
        },
      });

      if (result.isConfirmed) {
        SetMensaje("Cargando", "Activando notificación", 3000);
        StartCargando("Activando notificación");
        localStorage.setItem('deseanotificaciones', "SI");
        if (Capacitor.isNativePlatform()) {
          await requestPushPermission();
        } else {
          const token = await getToken(messaging, { vapidKey: "BGGnMVJTkNnbX1qjHffIfNJzDXfjiYAddEvqv0BqM4cd9Gt-10J6oVy98E8jbkY5bPjg5Egm-_z5MO5XDzkUBbQ" });
          await saveTokenAndSendToServer(token);
        }
      } else {
        localStorage.setItem('deseanotificaciones', "NO");
      }
    } catch (error) {
      BorrarTodosLosMensajes();
      StopCargando();
      SetMensaje("Error", "Error al activar notificacion", 3000);
      console.error('Error obteniendo token FCMs', error);
    } finally {
      isRequestingToken = false;
    }
  };

  onMessageListener = () => {
    if (Capacitor.isNativePlatform()) {
      return;
    }
    onMessage(messaging, message => {
      SetMensaje("Informacion", message.data.body, 3000);
      if (window.updatenoti) {
        var actualizar = false;
        if (message.data.actualizar && message.data.actualizar == "SI") {
          actualizar = true;
        }
        window.updatenoti(actualizar);
      }
    })
  };

  unsubscribeFromNotifications = async () => {
    try {
      const token = localStorage.getItem('fcm_token');
      if (token) {
        try {
          if (Capacitor.isNativePlatform()) {
            await unregister();
          } else {
            await deleteToken(messaging);
          }
        } catch (error) {
          StopCargando();
          SetMensaje("Error", "Error al desactivar notificaciones", 3000);
          console.error('Error al desuscribirse de las notificaciones:', error);
        }

        localStorage.removeItem('fcm_token');
        StartCargando("Desactivando notificacion");
        const userlogintokenString = localStorage.getItem('token');
        const userlogintoken = JSON.parse(userlogintokenString);
        const response = await Config.RemoveTokenNotificacion({ token: token }, userlogintoken)
        if (response.data.sucess) {
          StopCargando();
        } else {
          StopCargando();
          SetMensaje("Error", "Error al desactivar notificaciones", 3000);
        }

      } else {
        console.log("No hay token almacenado para borrar.");
      }
    } catch (error) {
      console.error("Error al borrar el token FCM:", error);
    }
  };

  unsubscribe = async () => {
    try {
      const token = localStorage.getItem('fcm_token');
      if (token) {
        await deleteToken(messaging);
      } else {
        console.log("No hay token almacenado para borrar.");
      }
    } catch (error) {
      console.error("Error al borrar el token FCM:", error);
    }
  };

  savetoken = async (token) => {
    await saveTokenAndSendToServer(token);
  };

} else {
  console.log("Firebase no se inicializa en entorno de desarrollo.");
}

module.exports = {
  requestForToken,
  onMessageListener,
  unsubscribeFromNotifications,
  unsubscribe,
  savetoken
};
